'use client';

import { type ComponentProps } from 'react';

import { TextInput } from '../inputs-core';
import {
  ProvinceCodeCombobox,
  ProvinceCodeDropdown,
  ProvinceNameDropdown,
} from './province-dropdown';
import { StateCodeCombobox, StateCodeDropdown, StateNameDropdown } from './state-dropdown';

const StateAndProvinceInput = ({
  variant,
  shouldUseName = false,
  shouldUseCombobox = false,
  ...opts
}: ComponentProps<typeof StateNameDropdown>
  & ComponentProps<typeof StateCodeCombobox>
  & ComponentProps<typeof ProvinceNameDropdown>
  & ComponentProps<typeof ProvinceCodeDropdown>
  & ComponentProps<typeof TextInput> & {
    variant?: 'state' | 'province' | 'other';
    shouldUseName?: boolean;
    shouldUseCombobox?: boolean;
  }) => {
  if (variant === 'state' && shouldUseName) return <StateNameDropdown {...opts} />;
  if (variant === 'state' && shouldUseCombobox) return <StateCodeCombobox {...opts} />;
  if (variant === 'state') return <StateCodeDropdown {...opts} />;
  if (variant === 'province' && shouldUseName) return <ProvinceNameDropdown {...opts} />;
  if (variant === 'province' && shouldUseCombobox) return <ProvinceCodeCombobox {...opts} />;
  if (variant === 'province') return <ProvinceCodeDropdown {...opts} />;
  return <TextInput {...opts} />;
};

export { StateAndProvinceInput };
